import type { RouteObject } from 'react-router';

import { NotFoundChildRoute } from 'src/app/NotFoundChildRoute';

export const romAllRequestsRoutes: RouteObject[] = [
  {
    index: true,
    lazy: () =>
      import(
        'src/features/trip/rom/all-requests/management/RomAllRequestsManagementRoute'
      ).then((m) => ({ Component: m.default })),
  },
  {
    path: '*',
    element: (
      <NotFoundChildRoute
        routePath="/trips/requests"
        linkText="Go back to trip requests"
      />
    ),
  },
];
